import { render, staticRenderFns } from "./Opstartsservice.vue?vue&type=template&id=16139a74&"
import script from "./Opstartsservice.vue?vue&type=script&lang=js&"
export * from "./Opstartsservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports